import { Calendar } from "primereact/calendar";

export default function MultiDatePicker({
    label,
    value,
    onChange,
    disabled = false,
    className = ""
}) {
    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            {label && (
                <label className="text-sm font-medium text-foreground/80">
                    {label}
                </label>
            )}

            <Calendar
                value={value}
                onChange={(e) => onChange(e.value)}
                selectionMode="multiple"
                dateFormat="dd/mm/yy"
                showIcon
                disabled={disabled}
                hideOnDateTimeSelect={false}
                touchUI={false}
                className="w-full"
                inputClassName="w-full"
                readOnlyInput
            />
        </div>
    );
}